export default __webpack_public_path__ + "static/81488-278e0fe9ee81719f5900ceb2b670da50.jpg";